import type { BetterstartIntegrationDefinition } from '@integration-engine/types.js'

export const r2Integration: BetterstartIntegrationDefinition = {
  id: 'r2',
  title: 'Cloudflare R2',
  description: 'Remote media storage for hosted deployments',
  kind: 'storage',
  version: '1.0.0',
  dependencies: [],
  conflicts: [],
  files: [
    {
      outputPath: 'lib/actions/r2/provider.ts',
      templatePath: 'actions/r2.ts'
    }
  ],
  packageDependencies: ['@aws-sdk/client-s3'],
  devDependencies: [],
  capabilities: {
    storageProvider: {
      provider: 'r2',
      importPath: '@admin/actions/r2/provider',
      exportName: 'r2StorageProvider'
    }
  },
  envSections: [
    {
      header: 'Storage (Cloudflare R2)',
      vars: [
        { key: 'BETTERSTART_R2_ACCOUNT_ID', value: '' },
        { key: 'BETTERSTART_R2_ACCESS_KEY_ID', value: '' },
        { key: 'BETTERSTART_R2_SECRET_ACCESS_KEY', value: '' },
        { key: 'BETTERSTART_R2_BUCKET_NAME', value: '' },
        { key: 'BETTERSTART_R2_PUBLIC_URL', value: '' }
      ]
    }
  ],
  configure: 'r2'
}
